// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  offerId: __t.u64().primaryKey().name("offer_id"),
  seller: __t.identity(),
  sigKey: __t.string().name("sig_key"),
  systemId: __t.string().name("system_id"),
  kind: __t.string(),
  scope: __t.string(),
  evidence: __t.string(),
  observedAt: __t.timestamp().name("observed_at"),
  price: __t.i64(),
  state: __t.string(),
  sold: __t.u32(),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
